export default __webpack_public_path__ + "static/media/logo.e3f0299f.svg";